import Formatter from "./Formatter.js";
import { TableColumnFormatter } from "./formatters/index.js";
/**
 * Instantiate a `Formatter` from the given settings.
 * @param dh The `dh` object
 * @param settings Optional settings to use
 * @returns A new `Formatter` instance
 */
export function createFormatterFromSettings(dh, settings) {
  var columnRules = getColumnFormats(settings);
  var dateTimeOptions = getDateTimeFormatterOptions(settings);
  var _ref = settings !== null && settings !== void 0 ? settings : {},
    defaultDecimalFormatOptions = _ref.defaultDecimalFormatOptions,
    defaultIntegerFormatOptions = _ref.defaultIntegerFormatOptions,
    truncateNumbersWithPound = _ref.truncateNumbersWithPound,
    showEmptyStrings = _ref.showEmptyStrings,
    showNullStrings = _ref.showNullStrings;
  return new Formatter(dh, columnRules, dateTimeOptions, defaultDecimalFormatOptions, defaultIntegerFormatOptions, truncateNumbersWithPound, showEmptyStrings, showNullStrings);
}
export function getColumnFormats(settings) {
  if (settings && settings.formatter) {
    var formatter = settings.formatter;
    return formatter;
  }
  return undefined;
}
export function getDateTimeFormatterOptions(settings) {
  return {
    timeZone: settings === null || settings === void 0 ? void 0 : settings.timeZone,
    defaultDateTimeFormatString: settings === null || settings === void 0 ? void 0 : settings.defaultDateTimeFormat,
    showTimeZone: settings === null || settings === void 0 ? void 0 : settings.showTimeZone,
    showTSeparator: settings === null || settings === void 0 ? void 0 : settings.showTSeparator
  };
}

/**
 * Check if the formatter has a custom format defined for the column name and type
 * @param formatter Formatter to check
 * @param columnName Column name
 * @param columnType Column type
 * @returns True, if a custom format is defined
 */
export function isCustomColumnFormatDefined(formatter, columnName, columnType) {
  var columnFormat = formatter.getColumnFormat(columnType, columnName);
  return columnFormat != null && (columnFormat.type === TableColumnFormatter.TYPE_CONTEXT_PRESET || columnFormat.type === TableColumnFormatter.TYPE_CONTEXT_CUSTOM);
}
export default {
  createFormatterFromSettings,
  getColumnFormats,
  getDateTimeFormatterOptions,
  isCustomColumnFormatDefined
};
//# sourceMappingURL=FormatterUtils.js.map